import api from '../API';

export interface Credentials {
  id: string,
  password: string
}

export interface Captcha {
  imageUrl: string
}

export interface MFA {
  type: 'authenticator_app'|'other_device',
  resendCodeIn: number|null
}

export interface LoginResult {
  error?: string
  captcha: Captcha|null,
  mfa: MFA|null,
}

export async function login(
  sessionId: number,
  credentials: Credentials,
): Promise<LoginResult> {
  const response = await api.post(`sessions/${sessionId}/login`, { credentials });
  return response.data;
}

export function wasSuccess(result: LoginResult): boolean {
  return (
    result.error === null
    && result.captcha === null
    && result.mfa === null
  );
}

export async function solveCaptcha(
  sessionId: string,
  solution: string,
): Promise<LoginResult> {
  const response = await api.post(
    `sessions/${sessionId}/login/solve-captcha`,
    { solution },
  );
  return response.data;
}

export async function submitEmailAuthCode(
  sessionId: string,
  code: string,
): Promise<LoginResult> {
  const response = await api.post(
    `sessions/${sessionId}/login/mfa/email/submit-code`,
    { code },
  );
  return response.data;
}

export async function submitAuthAppCode(
  sessionId: string,
  code: string,
): Promise<LoginResult> {
  const response = await api.post(
    `sessions/${sessionId}/login/mfa/auth-app/submit-code`,
    { code },
  );
  return response.data;
}

export async function submitSmsAuthCode(
  sessionId: string,
  code: string,
): Promise<LoginResult> {
  const response = await api.post(
    `sessions/${sessionId}/login/mfa/sms/submit-code`,
    { code },
  );
  return response.data;
}

export async function resendSmsAuthCode(sessionId: string): Promise<LoginResult> {
  const response = await api.post(
    `sessions/${sessionId}/login/mfa/sms/resend-code`,
  );
  return response.data;
}

export async function getStatus(sessionId: string): Promise<LoginResult> {
  const response = await api.get(`sessions/${sessionId}/login/status`);
  return response.data;
}
